module.exports = __webpack_public_path__ + "static/media/icon-question.639f25b3.svg";